/* eslint-disable quotes */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState } from 'react';
import { Alert, Box, Button, Grid, LinearProgress, Paper, Snackbar, SnackbarCloseReason, Typography, alpha, useTheme, Dialog,  DialogContent, DialogActions, 
} from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import * as yup from 'yup';
import { VTextField, VForm, useVForm, IVFormErrors, VSwitch, AutoCompleteGrupoDeProdutos, AutoCompleteSubgrupoProdutos, BasicSelect, VFieldMoney, VFieldMoneyNumber2} from '../../../shared/forms';
import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import { styled } from '@mui/material/styles';
import { AutoCompleteCfop } from '../../../shared/forms/AutoCompleteCfop';
import { ProdutorService } from '../../../shared/services/api/cadastros/ProdutorService';
import { ProdutosService } from '../../../shared/services/api/estoque/produtos/ProdutosService';
import { getAuth } from './../../../GlobalDecode';
import LocalGasStationIcon from '@mui/icons-material/LocalGasStation';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

interface IFormData {
  idgrupo: string | null;
  foto: string;
  localizado: string;
  marca: string;
  idsubgrupo: string | null;
  descricao: string;
  un: string;
  ean: string;
  eanentrada: string;
  infadd: string;
  origem: number;
  cfop: string;
  icms: number;
  cst: string;
  cstpis: string;
  cstipi: string;
  cstcofins: string;
  ppis: number;
  pcofins: number;
  pipi: number;
  ncm: string;
  cest: string;
  descanp: string;
  cprodanp: string;
  pnacional: number;
  pimportado: number;
  vpartida: number;
  preco: number;
  pvenda: number;
  ppromocao: number;
  picms: number;
  pfrete: number;
  pseguro: number;
  desconto: number;
  precocusto: number;
  codinterno: string;
  comissao: number;
  margem: number;
  estoqueminino: number;
  tax: boolean;
  status: boolean;
}

interface IFormDataItem {
  iditens: string;
  idprodutos: string;
  qtds: number;
  qtde: number;
  un: string;
  preco: number;
  ean?: string;
  ncm?: string;
  subtotal: number;
  desconto: number;
  voutros: number;
  total: number;
  filtro: string;
  referencia?: string;
  marca?: string;
  descricao: string;
}

const formValidationSchema: yup.ObjectSchema<IFormData> = yup.object().shape({
  idgrupo: yup.string().required(),
  idsubgrupo: yup.string().nullable().default(null),
  descricao: yup.string().required(),
  foto: yup.string().optional().default(''),
  un: yup.string().required(),
  ean: yup.string().required(),
  eanentrada: yup.string().required(),
  localizado: yup.string().optional().default(''),
  marca: yup.string().optional().default(''),
  infadd: yup.string().optional().default(''),
  origem: yup.number().optional().default(0),
  cfop: yup.string().required(),
  icms: yup.number().optional().default(0),
  cst: yup.string().required(),
  cstcofins: yup.string().required(),
  cstpis: yup.string().optional().default(''),
  cstipi: yup.string().optional().default(''),
  pcofins: yup.number().optional().default(0),
  pipi: yup.number().optional().default(0),
  ppis: yup.number().optional().default(0),
  ncm: yup.string().required().min(8).max(8),
  cest: yup.string().optional().default(''),
 descanp: yup
     .string()
     .default('')
     .test(
       'descanp-length',
       'Deve ter entre 2 e 95 caracteres',
       (value) => !value || (value.length >= 2 && value.length <= 95)
     ),
 
   cprodanp: yup
     .string()
     .default('')
     .test(
       'cprodanp-length',
       'Deve ter entre 9 e 9 caracteres',
       (value) => !value || (value.length >= 9 && value.length <= 9)
     ),
  pnacional: yup.number().optional().default(0),
  pimportado: yup.number().optional().default(0),
  vpartida: yup.number().optional().default(0),
  preco: yup.number().required().moreThan(0),
  pvenda: yup.number().required().moreThan(0),
  ppromocao: yup.number().optional().default(0),
  picms: yup.number().optional().default(0),
  pfrete: yup.number().optional().default(0),
  pseguro: yup.number().optional().default(0),
  precocusto: yup.number().optional().default(0),
  desconto: yup.number().optional().default(0),
  comissao: yup.number().optional().default(0),
  margem: yup.number().optional().default(0),
  codinterno: yup.string().optional().default(''),
  estoqueminino: yup.number().optional().default(0),
  status: yup.boolean().optional().default(true),
  tax: yup.boolean().optional().default(true),
});

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  borderRadius: '12px',
  boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
  backgroundColor: theme.palette.background.paper,
}));

const ModernLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 6,
  borderRadius: 3,
  marginBottom: theme.spacing(2),
}));

const RoundedTextField = styled(VTextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: '12px',
    backgroundColor: theme.palette.background.default,
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  '& .MuiInputLabel-root': {
    color: theme.palette.text.secondary,
  },
}));

const SectionBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  borderRadius: '12px',
  backgroundColor: theme.palette.mode === 'dark'
    ? alpha(theme.palette.background.default, 0.5)
    : alpha('#f5f5f5', 0.3),
  marginBottom: theme.spacing(2),
  border: `1px solid ${theme.palette.divider}`,
}));

const ContentContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  paddingLeft: 0,
  paddingRight: 0,
  marginLeft: 0,
  marginRight: 0,
  width: '100%',
  maxWidth: '100%',
}));

interface IDetalheDeProdutoDialogProps {
  open: boolean;
  id?: string;
  margem?: number;
  onClose: (shouldRefresh?: boolean) => void;
  value: string;
  status: boolean;
  dados?: IFormDataItem;
  onDados: (dados: IFormDataItem) => void;
}

export const DetalheDeProdutoDialog: React.FC<IDetalheDeProdutoDialogProps> = ({ open, id: propId, onClose, dados, margem, onDados }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { id = propId || 'novo' } = useParams<'id'>();
  const { formRef, save } = useVForm();
  const [isLoading, setIsLoading] = useState(false);
  const [image, setImage] = useState<string | null>(null);
  const [statusCheck, setStatusCheck] = useState<boolean>(true);
  const [nome, setNome] = useState('');
  const [openmsg, setOpenmsg] = useState(false);
  const [msg, setMsg] = useState('');
  const [tms, setTms] = useState<'warning' | 'error' | 'info' | 'success'>('warning');
  const [openConfirm, setOpenConfirm] = useState(false);
  const [openCombustivel, setOpenCombustivel] = useState(false);
  const auth = getAuth();
  const decimais = auth?.decimais ?? 2;

  const preencherFormulario = () => {
    if (!formRef.current) return;
    if (dados && dados.descricao) {
      if (dados.idprodutos && dados.idprodutos !== '' && dados.idprodutos !== '0') {
        setIsLoading(true);
        ProdutosService.getById(dados.idprodutos)
          .then((result) => {
            setIsLoading(false);
            if (result instanceof Error) {
              setTms('error');
              setMsg(result.message);
              setOpenmsg(true);
            } else {
              setNome(result.descricao);
              const formData = {
                ...result,
                idsubgrupo: result.idsubgrupo || null,
              };
              formRef.current?.setData(formData);
              setTimeout(() => {
                calcularPrecoCusto();
              }, 100);
            }
          });
      } else {
        const formData: Partial<IFormData> = {
          descricao: dados.descricao || '',
          un: dados.un || '',
          ean: dados.ean || 'SEM GTIN',
          eanentrada: dados.ean || 'SEM GTIN',
          marca: dados.marca || '',
          ncm: dados.ncm || '',
          preco: dados.preco || 0,
          idgrupo: '',
          idsubgrupo: null,
          foto: '',
          localizado: '',
          infadd: '',
          codinterno: '',
          origem: 0,
          cfop: '',
          icms: 0,
          cst: '',
          cstcofins: '',
          cstpis: '',
          cstipi: '',
          pcofins: 0,
          ppis: 0,
          pipi: 0,
          cest: '',
          descanp: '',
          cprodanp: '',
          pnacional: 0,
          pimportado: 0,
          vpartida: 0,
          pvenda: 0,
          ppromocao: 0,
          picms: 0,
          pfrete: 0,
          pseguro: 0,
          desconto: 0,
          comissao: 0,
          margem: margem ?? 0,
          estoqueminino: 0,
          tax: true,
          status: true,
        };

        formRef.current?.setData(formData);

        setTimeout(() => {
          calcularPrecoCusto();
          calcularPrecoVenda();
        }, 100);
      }
    } else if (id !== 'novo' && id !== propId) {
      // Buscar produto por ID
      setIsLoading(true);
      ProdutosService.getById(id)
        .then((result) => {
          setIsLoading(false);
          if (result instanceof Error) {
            setTms('error');
            setMsg(result.message);
            setOpenmsg(true);
          } else {
            setNome(result.descricao);
            const formData = {
              ...result,
              idsubgrupo: result.idsubgrupo || '',
            };
            formRef.current?.setData(formData);
            setTimeout(() => {
              calcularPrecoCusto();
            }, 100);
          }
        });
    } else {
      formRef.current.setData({
        idgrupo: '',
        idsubgrupo: null,
        descricao: '',
        foto: '',
        localizado: '',
        un: '',
        ean: 'SEM GTIN',
        eanentrada: 'SEM GTIN',
        marca: '',
        infadd: '',
        codinterno: '',
        origem: 0,
        cfop: '',
        icms: 0,
        cst: '',
        cstcofins: '08',
        cstpis: '08',
        cstipi: '',
        pcofins: 0,
        ppis: 0,
        pipi: 0,
        ncm: '',
        cest: '',
        descanp: '',
        cprodanp: '',
        pnacional: 0,
        pimportado: 0,
        vpartida: 0,
        preco: 0,
        pvenda: 0,
        ppromocao: 0,
        picms: 0,
        pfrete: 0,
        pseguro: 0,
        desconto: 0,
        margem: 0,
        estoqueminino: 0,
        tax: true,
        status: true,
      });
      setImage(null);
      setTimeout(() => {
        calcularPrecoCusto();
      }, 100);
    }
  };

  // Quando o dialog abrir ou os dados mudarem, preencher o formulário
  useEffect(() => {
    if (open) {
      // Pequeno delay para garantir que o formRef está pronto
      const timer = setTimeout(() => {
        preencherFormulario();
      }, 50);

      return () => clearTimeout(timer);
    }
  }, [open, dados, id]); // Adicionar 'dados' como dependência

  const handleCloseMsg = (
    event?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') return;
    setOpenmsg(false);
    if (tms === 'success') {
      onClose(true);
    }
  };


  const handleConfirmDelete = () => {
    ProdutorService.deleteById(id)
      .then(result => {
        if (result instanceof Error) {
          setOpenConfirm(false);
          setTms('error');
          setMsg(result.message);
          setOpenmsg(true);
        } else {
          setOpenConfirm(false);
          setTms('success');
          setMsg('Registro apagado com sucesso!');
          setOpenmsg(true);
        }
      });
  };

  const calcularPrecoVenda = () => {
    const data = formRef.current?.getData();

    const custo = calcularPrecoCusto();
    const margemValue = Number(data?.margem) || 0;

    if (custo <= 0) return;

    const pvenda = custo + (custo * margemValue / 100);

    formRef.current?.setFieldValue(
      'pvenda',
      formatarNumero(pvenda)
    );
  };

  const handleCancelDelete = () => setOpenConfirm(false);

  const formatarNumero = (valor: number) => {
    return Number(valor.toFixed(decimais === 4 ? 4 : 2));
  };

  const handleSaveForm = (formData: IFormData) => {
    const { status, ...dadosSemStatus } = formData;

    formValidationSchema
      .validate(dadosSemStatus, { abortEarly: false })
      .then((dadosValidados) => {
        setIsLoading(true);
        const dadosParaEnviar = id !== 'novo'
          ? { ...dadosValidados, status }
          : dadosValidados;
        ProdutosService.create(dadosParaEnviar)
          .then((result) => {
            setIsLoading(false);
            if (result instanceof Error) {
              setTms('error');
              setMsg(result.message);
              setOpenmsg(true);
            } else {
              setTms('success');
              setMsg('Cadastro concluído com sucesso!');
              setOpenmsg(true);
              if (onDados && result) {
                const updatedDados = {
                  ...dados,
                  idprodutos: String(result),
                  descricao: formData.descricao,
                  un: formData.un,
                  ean: formData.ean,
                  ncm: formData.ncm,
                  preco: formData.preco,
                } as IFormDataItem;
                onDados(updatedDados);
              }
            }
          });
      })
      .catch((errors: yup.ValidationError) => {
        const validationErrors: IVFormErrors = {};
        errors.inner.forEach(error => {
          if (!error.path) return;
          validationErrors[error.path] = error.message;
        });
        formRef.current?.setErrors(validationErrors);
      });
  };

  const parseMoney = (value: string | number | null | undefined): number => {
    if (typeof value === 'number') return value;
    if (!value) return 0;
    return Number(value.toString().replace(/\./g, '').replace(',', '.')) || 0;
  };

  const handleMargemChange = (margem: number) => {
    const custo = calcularPrecoCusto();
    if (custo <= 0) return;
    const pvenda = custo + (custo * margem / 100);
    formRef.current?.setFieldValue('pvenda', formatarNumero(pvenda));
  };

  const handlePrecoVendaChange = (pvenda: number) => {
    const custo = calcularPrecoCusto();
    if (custo <= 0) return;
    const margem = ((pvenda - custo) / custo) * 100;
    formRef.current?.setFieldValue('margem', Number(margem.toFixed(4)));
  };

  const calcularPrecoCusto = (override?: Partial<IFormData>) => {
    const data = formRef.current?.getData();
    const preco = parseMoney(override?.preco ?? data?.preco);
    const comissao = parseMoney(override?.comissao ?? data?.comissao);
    const icms = parseMoney(override?.icms ?? data?.icms);
    const seguro = parseMoney(override?.pseguro ?? data?.pseguro);
    const frete = parseMoney(override?.pfrete ?? data?.pfrete);

    const valorComissao = preco * (comissao / 100);
    const valorIcms = preco * (icms / 100);
    const valorFrete = preco * (frete / 100);

    const custo = preco + valorComissao + valorIcms + seguro + valorFrete;

    formRef.current?.setFieldValue('precocusto', formatarNumero(custo));
    return custo;
  };

  const handlePrecoCustoChange = (campo: keyof IFormData, valor: number) => {
    const custo = calcularPrecoCusto({ [campo]: valor });
    const data = formRef.current?.getData();
    const margem = parseMoney(data?.margem);

    if (!margem || margem === 0) {
      formRef.current?.setFieldValue('pvenda', formatarNumero(custo));
      return;
    }

    const pvenda = custo + (custo * margem / 100);
    formRef.current?.setFieldValue('pvenda', formatarNumero(pvenda));
  };

  const handleCloseDialog = () => {
    onClose(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleCloseDialog}
      maxWidth="xl"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '16px',
          height: '90vh',
          maxHeight: '90vh',
        }
      }}
    >

      <DialogContent dividers sx={{ p: 2, overflowY: 'auto' }}>
        <VForm ref={formRef} onSubmit={handleSaveForm}>
          <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={openmsg} autoHideDuration={2000} onClose={handleCloseMsg}>
            <Alert onClose={handleCloseMsg} severity={tms} variant="filled" sx={{ width: '100%', borderRadius: '12px' }}>
              {msg}
            </Alert>
          </Snackbar>

          <Snackbar open={openConfirm} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
            <Alert
              severity="warning"
              variant="filled"
              sx={{ display: 'flex', alignItems: 'center', width: '100%', borderRadius: '12px' }}
              action={
                <>
                  <Button color="inherit" size="small" onClick={handleConfirmDelete}>Sim</Button>
                  <Button color="inherit" size="small" onClick={handleCancelDelete}>Não</Button>
                </>
              }
            >
              Tem certeza que deseja excluir este registro?
            </Alert>
          </Snackbar>

          <ContentContainer>
            <StyledPaper elevation={0}>
              <Grid container direction="column" spacing={3}>
                {isLoading && (
                  <Grid item>
                    <ModernLinearProgress variant='indeterminate' />
                  </Grid>
                )}

                <Grid item>
                  <SectionBox>
                    <Grid container spacing={2} alignItems="center">
                      <Grid item xs={12} sm={12} md={2.5}>
                        <Box width='100%' display="flex" justifyContent="center">
                          <Avatar
                            variant='rounded'
                            alt='Produto'
                            src={image || undefined}
                            sx={{
                              width: { xs: 150, sm: 150, md: 150 },
                              height: { xs: 180, sm: 180, md: 183 },
                              backgroundColor: theme.palette.mode === 'dark' ? '#424242' : '#f5f5f5',
                            }}
                          />
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={12} md={9.5}>
                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={12} md={8}>
                            <RoundedTextField
                              fullWidth
                              size='small'
                              name='descricao'
                              disabled={isLoading}
                              label='Descrição'
                            />
                          </Grid>
                          <Grid item xs={6} sm={6} md={4}>
                            <RoundedTextField
                              fullWidth
                              size='small'
                              name='marca'
                              disabled={isLoading}
                              label='Marca'
                            />
                          </Grid>
                          <Grid item xs={6} sm={6} md={4}>
                            <RoundedTextField
                              fullWidth
                              size='small'
                              name='ean'
                              disabled={isLoading}
                              label='Código EAN'
                            />
                          </Grid>
                          <Grid item xs={6} sm={6} md={4}>
                           <RoundedTextField
                              fullWidth
                              size='small'
                              name='eanentrada'
                              disabled={isLoading}
                              label='Código EAN de Entrada'
                            />
                          </Grid>
                          <Grid item xs={3} sm={3} md={2}>
                            <RoundedTextField
                              fullWidth
                              size='small'
                              name='un'
                              disabled={isLoading}
                              label='UN'
                            />
                          </Grid>
                          <Grid item xs={3} sm={3} md={2}>
                            <RoundedTextField
                              fullWidth
                              size='small'
                              name='localizado'
                              disabled={isLoading}
                              label='Local'
                            />
                          </Grid>
                          <Grid item xs={6} sm={6} md={4}>
                            <AutoCompleteGrupoDeProdutos />
                          </Grid>
                          <Grid item xs={6} sm={6} md={3}>
                            <AutoCompleteSubgrupoProdutos />
                          </Grid>
                          <Grid item xs={6} sm={6} md={3}>
                            <RoundedTextField
                              fullWidth
                              size='small'
                              name='codinterno'
                              disabled={isLoading}
                              label='Codigo Int'
                            />
                          </Grid>
                          <Grid item xs={6} sm={3} md={2}>
                            <RoundedTextField
                              fullWidth
                              size="small"
                              name="estoqueminino"
                              disabled={isLoading}
                              label="Estoque Minimo"
                            />
                          </Grid>
                          <Grid item xs={3} sm={3} md={1.5}>
                            <VSwitch
                              name='tax'
                              label='TAX'
                              value={statusCheck}
                              fdisabled={isLoading}
                              aliamento='start'
                            />
                          </Grid>
                          {id !== 'novo' && (
                            <Grid item xs={3} sm={3} md={2}>
                              <VSwitch
                                name='status'
                                label='Status'
                                value={statusCheck}
                                fdisabled={isLoading}
                                aliamento='start'
                              />
                            </Grid>
                          )}
                        </Grid>
                      </Grid>
                      <Grid item xs={12}>
                        <RoundedTextField
                          fullWidth
                          size='small'
                          name='infadd'
                          disabled={isLoading}
                          label='Observações'
                          multiline
                          rows={2}
                        />
                      </Grid>
                    </Grid>
                  </SectionBox>
                </Grid>

                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <SectionBox>
                      <Typography variant="h6" gutterBottom align="center" sx={{ mt: 1, mb: 2.1 }}>
                        Tributos
                      </Typography>
                      <Grid container spacing={1.5}>
                        <Grid item xs={6}>
                          <RoundedTextField fullWidth size="small" name="ncm" disabled={isLoading} label="NCM" />
                        </Grid>
                        <Grid item xs={6}>
                          <BasicSelect
                            name='origem'
                            label='Origem'
                            data={[
                              { nameBD: '0', descricao: '0 - Nacional' },
                              { nameBD: '1', descricao: '01 - Estrangeira - Importação direta' },
                              { nameBD: '2', descricao: '02 - Estrangeira - Adquirida no mercado interno' },
                              { nameBD: '3', descricao: '03 - Nacional, mercadoria ou bem com Conteúdo de Importação superior a 40%' },
                              { nameBD: '4', descricao: '04 - Produto nacional fabricado conforme a legislação vigente.' },
                              { nameBD: '5', descricao: '05 - Nacional, mercadoria ou bem com Conteúdo de Importação inferior ou igual a 40%;' },
                              { nameBD: '50', descricao: '50 - Nacional, mercadoria ou bem com Conteúdo de Importação inferior ou igual a 40%;' },

                            ]}
                            disabled={false}
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <AutoCompleteCfop />
                        </Grid>
                        <Grid item xs={6}>
                          <BasicSelect
                            name='cst'
                            label='Cst'
                            data={[
                              { nameBD: '101', descricao: '101' },
                              { nameBD: '102', descricao: '102' },
                              { nameBD: '103', descricao: '103' },
                              { nameBD: '203', descricao: '203' },
                              { nameBD: '300', descricao: '300' },
                              { nameBD: '400', descricao: '400' },
                              { nameBD: '500', descricao: '500' },
                              { nameBD: '900', descricao: '900' },
                            ]}
                            disabled={false}
                          />
                        </Grid>
                        <Grid item xs={3}>
                          <BasicSelect
                            name='cstcofins'
                            label='CST CONFIS'
                            data={[
                              { nameBD: '01', descricao: '01' },
                              { nameBD: '02', descricao: '02' },
                              { nameBD: '03', descricao: '03' },
                              { nameBD: '04', descricao: '04' },
                              { nameBD: '05', descricao: '05' },
                              { nameBD: '06', descricao: '06' },
                              { nameBD: '07', descricao: '07' },
                              { nameBD: '08', descricao: '08' },
                              { nameBD: '09', descricao: '09' },
                              { nameBD: '49', descricao: '49' },
                              { nameBD: '50', descricao: '50' },
                              { nameBD: '51', descricao: '51' },
                              { nameBD: '52', descricao: '52' },
                              { nameBD: '53', descricao: '53' },
                              { nameBD: '54', descricao: '54' },
                              { nameBD: '55', descricao: '55' },
                              { nameBD: '56', descricao: '56' },
                              { nameBD: '60', descricao: '60' },
                              { nameBD: '61', descricao: '61' },
                              { nameBD: '62', descricao: '62' },
                              { nameBD: '63', descricao: '63' },
                              { nameBD: '64', descricao: '64' },
                              { nameBD: '65', descricao: '65' },
                              { nameBD: '66', descricao: '66' },
                              { nameBD: '67', descricao: '67' },
                              { nameBD: '70', descricao: '70' },
                              { nameBD: '71', descricao: '71' },
                              { nameBD: '72', descricao: '72' },
                              { nameBD: '73', descricao: '73' },
                              { nameBD: '74', descricao: '74' },
                              { nameBD: '75', descricao: '75' },
                              { nameBD: '98', descricao: '98' },
                              { nameBD: '99', descricao: '99' },
                            ]}
                            disabled={false}
                          />
                        </Grid>
                        <Grid item xs={3}>
                          <VFieldMoney fullWidth size='small' name='pcofins' label='Percentual CONFIS' disabled={false} />
                        </Grid>
                        <Grid item xs={3}>
                          <BasicSelect
                            name='cstpis'
                            label='CST PIS'
                            data={[
                              { nameBD: '01', descricao: '01' },
                              { nameBD: '02', descricao: '02' },
                              { nameBD: '03', descricao: '03' },
                              { nameBD: '04', descricao: '04' },
                              { nameBD: '05', descricao: '05' },
                              { nameBD: '06', descricao: '06' },
                              { nameBD: '07', descricao: '07' },
                              { nameBD: '08', descricao: '08' },
                              { nameBD: '09', descricao: '09' },
                              { nameBD: '49', descricao: '49' },
                              { nameBD: '50', descricao: '50' },
                              { nameBD: '51', descricao: '51' },
                              { nameBD: '52', descricao: '52' },
                              { nameBD: '53', descricao: '53' },
                              { nameBD: '54', descricao: '54' },
                              { nameBD: '55', descricao: '55' },
                              { nameBD: '56', descricao: '56' },
                              { nameBD: '60', descricao: '60' },
                              { nameBD: '61', descricao: '61' },
                              { nameBD: '62', descricao: '62' },
                              { nameBD: '63', descricao: '63' },
                              { nameBD: '64', descricao: '64' },
                              { nameBD: '65', descricao: '65' },
                              { nameBD: '66', descricao: '66' },
                              { nameBD: '67', descricao: '67' },
                              { nameBD: '70', descricao: '70' },
                              { nameBD: '71', descricao: '71' },
                              { nameBD: '72', descricao: '72' },
                              { nameBD: '73', descricao: '73' },
                              { nameBD: '74', descricao: '74' },
                              { nameBD: '75', descricao: '75' },
                              { nameBD: '98', descricao: '98' },
                              { nameBD: '99', descricao: '99' },
                            ]}
                            disabled={false}
                          />
                        </Grid>
                        <Grid item xs={3}>
                          <VFieldMoney fullWidth size='small' name='ppis' label='Per PIS' disabled={false} />
                        </Grid>
                        <Grid item xs={3}>
                          <BasicSelect
                            name='cstipi'
                            label='CST IPI'
                            data={[
                              { nameBD: '', descricao: 'vazio' },
                              { nameBD: '00', descricao: '00' },
                              { nameBD: '49', descricao: '49' },
                              { nameBD: '50', descricao: '50' },
                              { nameBD: '99', descricao: '99' },
                              { nameBD: '01', descricao: '01' },
                              { nameBD: '02', descricao: '02' },
                              { nameBD: '03', descricao: '03' },
                              { nameBD: '04', descricao: '04' },
                              { nameBD: '05', descricao: '05' },
                              { nameBD: '51', descricao: '51' },
                              { nameBD: '52', descricao: '52' },
                              { nameBD: '53', descricao: '53' },
                              { nameBD: '54', descricao: '54' },
                              { nameBD: '55', descricao: '55' },
                            ]}
                            disabled={false}
                          />
                        </Grid>
                        <Grid item xs={3}>
                          <VFieldMoney fullWidth size='small' name='pipi' label='Percentual IPI' disabled={false} />
                        </Grid>
                        <Grid item xs={3}>
                          <VFieldMoney fullWidth size="small" name="picms" disabled={isLoading} label="P.ICMS" />
                        </Grid>
                        <Grid item xs={3}>
                          <RoundedTextField fullWidth size="small" name="cest" disabled={isLoading} label="CEST" />
                        </Grid>
                      </Grid>
                    </SectionBox>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <SectionBox>
                      <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ cursor: 'pointer' }} onClick={() => setOpenCombustivel(prev => !prev)}>
                        <Box display="flex" alignItems="center" gap={1}>
                          <LocalGasStationIcon sx={{ fontSize: 18 }} />
                          <Typography variant="body2" fontWeight={600}>Somente para Combustíveis</Typography>
                        </Box>
                        <ExpandMoreIcon sx={{ fontSize: 20, transform: openCombustivel ? 'rotate(180deg)' : 'rotate(0deg)', transition: '0.25s' }} />
                      </Box>
                      {openCombustivel && (
                        <Grid container spacing={1.5} sx={{ mt: 1 }}>
                          <Grid item xs={8}><RoundedTextField fullWidth size="small" name="descanp" disabled={isLoading} label="Descrição ANP" /></Grid>
                          <Grid item xs={4}><RoundedTextField fullWidth size="small" name="cprodanp" disabled={isLoading} label="Código ANP" /></Grid>
                          <Grid item xs={4}><RoundedTextField fullWidth size="small" name="pnacional" disabled={isLoading} label="Percentual Nacional" /></Grid>
                          <Grid item xs={4}><RoundedTextField fullWidth size="small" name="pimportado" disabled={isLoading} label="Percentual N. Importado" /></Grid>
                          <Grid item xs={4}><RoundedTextField fullWidth size="small" name="vpartida" disabled={isLoading} label="Valor Partida" /></Grid>
                        </Grid>
                      )}
                    </SectionBox>
                    <SectionBox>
                      <Typography variant="h6" gutterBottom align='center'>Formando Preço</Typography>
                      <Grid container spacing={1.5}>
                        <Grid item xs={3}>
                          <VFieldMoneyNumber2 fullWidth size="small" name="preco" disabled={isLoading} label="Preço De Compra" calcular={(valor) => handlePrecoCustoChange('preco', valor)} />
                        </Grid>
                        <Grid item xs={3}>
                          <VFieldMoneyNumber2 fullWidth size="small" name="comissao" disabled={isLoading} label="Comissão (%)" calcular={(valor) => handlePrecoCustoChange('comissao', valor)} />
                        </Grid>
                        <Grid item xs={3}>
                          <VFieldMoneyNumber2 fullWidth size="small" name="icms" disabled={isLoading} label="ICMS (%)" calcular={(valor) => handlePrecoCustoChange('icms', valor)} />
                        </Grid>
                        <Grid item xs={3}>
                          <VFieldMoneyNumber2 fullWidth size="small" name="pseguro" disabled={isLoading} label="Seguro" calcular={(valor) => handlePrecoCustoChange('pseguro', valor)} />
                        </Grid>
                        <Grid item xs={3}>
                          <VFieldMoneyNumber2 fullWidth size="small" name="pfrete" disabled={isLoading} label="Frete (%)" calcular={(valor) => handlePrecoCustoChange('pfrete', valor)} />
                        </Grid>
                        <Grid item xs={3}>
                          <VFieldMoneyNumber2 fullWidth size="small" name="desconto" disabled={isLoading} label="Desconto" />
                        </Grid>
                        <Grid item xs={3}>
                          <VFieldMoneyNumber2 fullWidth size="small" name="ppromocao" disabled={isLoading} label="Preço promoção" />
                        </Grid>
                        <Grid item xs={3}>
                          <VFieldMoneyNumber2 fullWidth size="small" name="precocusto" disabled={true} label="Preço De Custo" />
                        </Grid>
                        <Grid item xs={6}>
                          <VFieldMoneyNumber2 fullWidth size="small" name="margem" disabled={isLoading} label="Mar. Lucro (%)" calcular={handleMargemChange} />
                        </Grid>
                        <Grid item xs={6}>
                          <VFieldMoneyNumber2 fullWidth size='small' name="pvenda" disabled={isLoading} label="Preço Venda" calcular={handlePrecoVendaChange} />
                        </Grid>
                      </Grid>
                    </SectionBox>
                  </Grid>
                </Grid>
              </Grid>
            </StyledPaper>
          </ContentContainer>
        </VForm>
      </DialogContent>

      <DialogActions sx={{ p: 2, borderTop: `1px solid ${theme.palette.divider}` }}>
        <Button onClick={handleCloseDialog} variant="outlined" sx={{ borderRadius: '20px' }}>Cancelar</Button>
        <Button onClick={save} variant="contained" disabled={isLoading} sx={{ borderRadius: '20px' }}>Salvar</Button>
      </DialogActions>
    </Dialog>
  );
};